export var annotations = [
  {
    "xVal": 800000,
    "yVal": 50,
    "path": "",
    "label_name": "caption1 story_board",
    "text": "In 2005, Manafort founded Davis Manafort Partners, a political consulting firm, with staff in the US, the Ukraine and Russia. The pro-Russian Ukrainian Party of Regions and its members started consulting with Manafort in 2006. The first transaction detailed in the indictment occured two years later on June 10, 2008.",
    "textOffset": [
      0,
      0
    ]
  },
  {
    "xVal": 800000,
    "yVal": 990,
    "path": "",
    "label_name": "caption2 story_board",
    "text": "In 2011, Manafort created an international arm of the political consulting firm called Davis Manafort Partners International. He used it to work with foreign clients, including Ukraine’s government and the Party of Regions.",
    "textOffset": [
      0,
      0
    ]
  },
  {
    "xVal": 800000,
    "yVal": 1150,
    "path": "",
    "label_name": "caption3 story_board",
    "text": "In 2012, the European Centre for A Modern Ukraine, Belgium-based mouthpiece for Viktor Yanukovych and the Party of Regions, was created. Manafort, Gates, and others used it to lobby and conduct public relations campaigns in the US and Europe for the Ukraine regime.",
    "textOffset": [
      0,
      0
    ]
  },
  {
    "xVal": 800000,
    "yVal": 2031,
    "path": "",
    "label_name": "caption4 story_board",
    "text": "In 2014, Viktor Yanukovych fled for Russia. The European Centre for A Modern Ukraine ceased to operate.",
    "textOffset": [
      0,
      0
    ]
  },
  {
    "xVal": 320000,
    "yVal": 890,
    "path": "M-20,0,L-5,0",
    "label_name": "data_label",
    "text": "A clothing store in Beverly Hills received $520,440 in payments between 2008 and 2012 — with the biggest one-time wire transfer being $128,280.",
    "textOffset": [
      0,
      0
    ]
  },
  {
    "xVal": 450000,
    "yVal": 1600,
    "path": "",
    "label_name": "data_label",
    "text": "Companies specializing in all forms of home improvement, including landscaping, housekeeping and home entertainment, received more than $8 million in transfers. To the left are some of the highest transactions.",
    "textOffset": [
      0,
      0
    ]
  },
  {
    "xVal": 505000,
    "yVal": 736,
    "path": "M-25,0,L-5,0",
    "label_name": "data_label",
    "text": "Two Cyprus-based companies, at least one of which is controlled by both Manafort and Gates, wire $1.03 million to an antique rug store in Alexandria, Virginia, and a business related to it.",
    "textOffset": [
      0,
      0
    ]
  },
  {
    "xVal": 1100000,
    "yVal": 1470,
    "path": "",
    "label_name": "data_label",
    "text": "Manafort made four wire transfers to buy two properties in New York and one in Arlington, totaling $6.4 million. He did not report these purchases in his 2012 tax return.",
    "textOffset": [
      0,
      0
    ]
  }
];



// WEBPACK FOOTER //
// js/annotations.js